import React, { useContext, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createBrowserRouter, Navigate, RouterProvider, useLocation, useNavigate } from "react-router-dom";
import ErrorPage from './components/pagine/ErrorPage/ErroPage';
import { StepperStartUp } from './components/pagine/getStarted/stepper/startUp/Stepper/StepperStartUp/StepperStartUp';
import { StepperCorporate } from './components/pagine/getStarted/stepper/corporates/Stepper/StepperCorporates';
import { Login, GetStarted, UpgradePlan, Billings, ProfilePreview, ChatMobilePage, ChatMessageMobilePage, UserEditProfile, routes, ServicesDetail, Services } from './components/pagine';
import { Profile } from './components/pagine/Profile';
import { EditCorporateProfile, EditStartupProfile } from './components/pagine/EditProfile';
import { AppGeneralContext, AppGeneralContextProvider } from './shared/GeneralContext/GeneralContext';
import axios from 'axios';
import { setupAxios } from 'shared/auth/authHelpers';
import { AuthProvider } from 'shared/auth';
import { LinkedInPage } from 'components/pagine/LinkedInPage';
import { GuestContextProvider } from 'shared/GeneralContext/GuestContext';
import { Bookingpage } from 'components/pagine/BookingPage/Bookingpage';


setupAxios(axios)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "getStarted",
        element: <GetStarted />
      },
      {
        path: "getStarted-startup",
        element: <GetStarted />
      },
      {
        path: "getStarted-corporate",
        element: <GetStarted />
      },
      {
        path: "login",
        element: <Login />
      },
      {
        path: "login-startup",
        element: <Login />
      },
      {
        path: "login-corporate",
        element: <Login />
      },
      {
        path: routes.LINKEDIN,
        element: <LinkedInPage />
      },
      {
        path: "getStarted/startup",
        element: <StepperStartUp />
      },
      {
        path: "getStarted/corporate",
        element: <StepperCorporate />
      },
      {
        path: "start-up/profile",
        element: <Profile />,
      },
      {
        path: "start-up/edit-profile",
        element: <UserEditProfile />,
      },
      {
        path: "start-up/profile/messaging",
        element: <ChatMobilePage />,
      },
      {
        path: "start-up/profile/messaging/:matchId",
        element: <ChatMessageMobilePage />,
      },

      {
        path: "start-up/profile/billings",
        element: <Billings />,
      },
      {
        path: "start-up/profile/services",
        element: <Services />,
      },
      {
        path: "start-up/profile/services/:serviceId/:comeBackProfile",
        element: <ServicesDetail />,
      },
      {
        path: "start-up/profile/upgrade-plan",
        element: <UpgradePlan />,
      },
      {
        path: "corporate/profile",
        element: <Profile />,
      },
      {
        path: "corporate/edit-profile",
        element: <UserEditProfile />,
      },
      {
        path: "corporate/startup-profile/:startupId",
        element: <ProfilePreview />,
      },
      {
        path: "corporate/match/:startupId",
        element: <Bookingpage />,
      },
      {
        path: "corporate/profile/messaging",
        element: <ChatMobilePage />,
      },
      {
        path: "corporate/profile/messaging/:matchId",
        element: <ChatMessageMobilePage />,
      },
      {
        path: "/",
        element: <Navigate to="/login" />
      },
    ]
  },
]);


root.render(
  <React.StrictMode>
    <GuestContextProvider>
      <AppGeneralContextProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </AppGeneralContextProvider>
    </GuestContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
